var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar yhc-bgc-white"},[_c('div'),_c('div',{staticClass:"right-menu"},[_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.logout}},[_vm._v("退出登录")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }